import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  
}

const ContractulAccountSimplifiedHeader = (props: Props) => {
  // translations
  const tLabels = useTranslation("contractualAccounts\\contractualAccounts").t;

  // render 
  return (
    <div className="d-none d-lg-block px-3 mb-2 text-muted font-weight-bold mr-5">
      <div className="row no-gutters align-items-end">
          <div className="col-lg-6">
            <div className="row no-gutters align-items-center">
              <div className="col-lg-5">
                {tLabels("contractulAccountSimplifiedHeader.number")}
              </div>
              <div className="col-lg-7 pl-lg-4 pr-lg-3">
                {tLabels("contractulAccountSimplifiedHeader.name")}
              </div>
            </div>
          </div>
          <div className="d-none d-lg-block col-lg-2">
            {tLabels("contractulAccountSimplifiedHeader.variableSymbol")}
          </div>
          <div className="col-lg-4 text-center">
            <div className="row no-gutters align-items-end">
              <div className="col-auto col-lg-4">
                <span className="d-lg-none d-xl-inline">{tLabels("contractulAccountSimplifiedHeader.billingCycle.desktop")}</span>
                <span className="d-xl-none">{tLabels("contractulAccountSimplifiedHeader.billingCycle.mobile")}</span>
              </div> 
              <div className="col-auto col-lg-3 px-2 px-lg-0">
                <span className="d-lg-none d-xl-inline">{tLabels("contractulAccountSimplifiedHeader.contractCount.desktop")}</span>
                <span className="d-xl-none">{tLabels("contractulAccountSimplifiedHeader.contractCount.mobile")}</span>
              </div>
              <div className="col-auto col-lg-5">
                {tLabels("contractulAccountSimplifiedHeader.contractualAccountStatus")}
              </div>
            </div>
          </div>
        </div>
    </div>
  )
}

export default ContractulAccountSimplifiedHeader;
